export const COMPANY_FIELDS = "COMPANY_FIELDS";
export const COMPANY_DETAILS = "COMPANY_DETAILS";
